import NotificationsPage from "components/pages/NotificationsPage";

export default function CaptureNotifiAlertAdded(props) {
    return <NotificationsPage />
}